import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_DEPOSIT_LEDGER_ALL,
    GET_DEPOSIT_LEDGER_USER,
    DEPOSIT_LEDGER_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get All Deposit Ledger
export const getDepositLedgerAll = (filters) => async dispatch => {
    dispatch({ type: DEPOSIT_LEDGER_LOADING });
    try {
        const queryString = filters ? `?${filters}` : '';
        const res = await axios.get(`${API_URL}/deposit-ledger/all${queryString}`);
        if(res.data.success){
            dispatch({
                type: GET_DEPOSIT_LEDGER_ALL,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched deposit ledger', 'success') );
        } else {
            dispatch( setAlert( res.data.error, 'danger' ) );
        }
    } catch ( err ) {
        dispatch( setAlert( 'Failed to fetch deposit ledger', 'danger' ) );
    }
};

// Get User's Deposit Ledger
export const getDepositLedgerUser = (userId, filters) => async dispatch => {
    dispatch({ type: DEPOSIT_LEDGER_LOADING });
    try {
        const queryString = filters ? `?${filters}` : '';
        const res = await axios.get(`${API_URL}/deposit-ledger/user/${userId}${queryString}`);
        if(res.data.success){
            dispatch({
                type: GET_DEPOSIT_LEDGER_USER,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched user deposit ledger', 'success') );
        } else {
            dispatch( setAlert( res.data.error, 'danger' ) );
        }
    } catch ( err ) {
        dispatch( setAlert( 'Failed to fetch user deposit ledger', 'danger' ) );
    }
}; 